export default class HedgingFields {
    static readonly UseFcmAccountFromPosition: string = "usefcmaccountfromposition";
    static readonly FcmAccountId: string = "fcmaccountid";
    static readonly UseMiniFcmAccountFromPosition: string = "useminifcmaccountfromposition";
    static readonly MiniContractFcmAccountId: string = "minicontractfcmaccountid";
    static readonly FullContractMinOffer: string = "fullcontractminoffer";
    static readonly MiniContractMinOffer: string = "minicontractminoffer";
    static readonly UseFullContractMinOfferFromPosition: string = "usefullcontractminofferfromposition";
    static readonly UseMiniContractMinOfferFromPosition: string = "useminicontractminofferfromposition";
}